// @ts-nocheck
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { IconPresentationProps } from "@insite/mobius/Icon";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import EditFill from "@store/Library/Components/Toolkit/Icons/Edit/EditFill";
import TrashFill from "@store/Library/Components/Toolkit/Icons/Trash/TrashFill";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
import { linkGetIconProps } from "@store/Themes/common/props/link";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins/icon";
import { css } from "styled-components";

const cardGap = 10;
const cardSpacing = pxToRem(cardGap);

export interface SavedPaymentsProps {
    listContainer?: GridContainerProps;
    listGridItem?: GridItemProps;
    card?: SavedPaymentsCardProps;
}

export interface SavedPaymentsCardProps {
    descriptionWrapper?: InjectableCss;
    icon?: IconPresentationProps;
    descriptionText?: TypographyPresentationProps;
    descriptionTextNote?: TypographyPresentationProps;
    container?: GridContainerProps;
    gridItem?: GridItemProps;
    infoContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    infoLabel?: TypographyPresentationProps;
    infoValue?: TypographyPresentationProps;
    actionsWrapper?: InjectableCss;
    editLink?: LinkPresentationProps;
    deleteLink?: LinkPresentationProps;
}

const cardLinkProps: LinkPresentationProps = {
    css: css`
        ${linkActionStyles()}
        ${inlineSeparatorStyles({ spacing: pxToRem(16), width: pxToRem(0), color: "text.accent" })}
    `,
};

export const savedPaymentsProps: SavedPaymentsProps = {
    listContainer: { gap: 20 },
    listGridItem: { width: [12, 6, 12, 6, 6] },
    card: {
        descriptionWrapper: {
            css: css`
                display: flex;
                column-gap: ${pxToRem(10)};
                align-items: flex-start;
                padding-bottom: ${pxToRem(15)};
                margin-bottom: ${pxToRem(15)};
                border-bottom: ${pxToRem(1)} solid ${getColor("common.border")};
                line-height: ${x => x.theme.design.typography.lineHeight.small};
            `,
        },
        icon: {
            css: css`
                ${iconScalableStyles("3.5em")};
                margin-top: 0.16em;

                > svg {
                    height: auto;
                }
            `,
        },
        descriptionText: {
            css: css`
                font-weight: ${x => x.theme.design.typography.weight.bold};
            `,
        },
        descriptionTextNote: {
            css: css`
                display: block;
                margin-top: 0.2em;
                font-size: 0.8em;
                font-weight: ${x => x.theme.design.typography.weight.base};
            `,
        },
        container: { gap: cardGap },
        gridItem: {
            width: [12, 12, 6, 6, 6],
            css: css`
                flex-direction: column;
            `,
        },
        infoContainer: { gap: cardGap },
        infoGridItem: {
            width: 12,
            css: css`
                flex-direction: column;
            `,
        },
        infoLabel: {
            css: css`
                display: block;
                font-weight: ${x => x.theme.design.typography.weight.bold};
            `,
        },
        infoValue: {
            css: css`
                word-break: break-word;
            `,
        },
        actionsWrapper: {
            css: css`
                ${spacingStyles(cardSpacing, null)}
                display: flex;
            `,
        },
        editLink: mergeProps(cardLinkProps, { icon: linkGetIconProps(EditFill) }),
        deleteLink: mergeProps(cardLinkProps, { icon: linkGetIconProps(TrashFill) }),
    },
};
